import gsap from "gsap";
import quick from './quick.js';

quick();

let particle = function () {
    particlesJS("particles-box", {
        "particles": {
            "number": {
                "value": 100,
                "density": {
                    "enable": true,
                    "value_area": 3000
                }
            },
            "color": {
                "value": "#ff7800"
            },
            "shape": {
                "type": "circle",
                "stroke": {
                    "width": 0,
                    "color": "#000000"
                },
                "polygon": {
                    "nb_sides": 4
                },
                "image": {
                    "src": "img/github.svg",
                    "width": 100,
                    "height": 100
                }
            },
            "opacity": {
                "value": 0.8,
                "random": true,
                "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                }
            },
            "size": {
                "value": 2,
                "random": true,
                "anim": {
                    "enable": true,
                    "speed": 5,
                    "size_min": 0,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": false,
                "distance": 500,
                "color": "#ffffff",
                "opacity": 0.4,
                "width": 2
            },
            "move": {
                "enable": true,
                "speed": 6,
                "direction": "top",
                "random": true,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": false,
                    "mode": "bubble"
                },
                "onclick": {
                    "enable": false,
                    "mode": "repulse"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 0.5
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 4,
                    "duration": 0.3,
                    "opacity": 1,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200,
                    "duration": 0.4
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true
    });
}

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        cookie:{
            type:'year',
            key:'INDEX_WEB_VISIT_bns_220316_update',
            value:false
        },
        home:true,
        event:false,
        update:true,
        sns:true,
        theme:'black'
    },
});



promokit.preload({
    complete: function() {
        ani_main.seek(0);
        // _layer.open();
    }
});

promokit.video({
    el: '#video-bg-1',
    url: 'https://vod.plaync.com/BS/update/220316/Warrior_BG.mp4',
    loop: true,
    autoplay: true,
    mute: true,
    preload: true,
    resizeTarget: 'window'
});

promokit.video({
    el: '#video-bg-2',
    url: 'https://vod.plaync.com/BS/update/220316/Dungeon_BG.mp4',
    loop: true,
    autoplay: true,
    mute: true,
    preload: true,
    resizeTarget: 'window'
});


let currentTop,delta;
var flag = false;
$('#container').on('scroll touchmove mousewheel DOMMouseScroll', function(event) {
    currentTop = $(window).scrollTop();
    var E = event.originalEvent;
    delta = 0;
    if (E.detail)
        delta = E.detail * -40;
    else
        delta = E.wheelDelta;

    if(!flag){
        if(delta < 0 && (currentTop < $('#section-1').offset().top/2)){
            // 마우스 휠을 아래로 내렸을 경우
            flag = true;
            $("html,body").stop().animate({
                scrollTop: $('#section-1').offset().top + 'px'
            }, {
                duration: 700,
                complete: function () {
                    flag = false;
                    // _remote();
                }
            });
        }
    }
    else{
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
});


var _layer = promokit.layer({
    el: '.p-header__layer',
    buttons: '.btn-play',
    autoplay: _video
});

var _video = promokit.youtube({
    el: '.p-header__layer',
    youtubeId: 'owNOADBfmCU',
    autoplay: false,
    preload: false,
    youtubeLink: true,
    controls: true
});

$('.btn-play').on('click',function (e) {
    e.preventDefault();
    // window.open('https://www.youtube.com/watch?v=owNOADBfmCU&feature=youtu.be');
    _layer.open();
});



$('.p-header__util li:nth-child(1) a').on('click',function (e) {
    e.preventDefault();
    window.open('https://bns.plaync.com/board/update/view?articleId=623a64ecee130b45abb71009&viewMode=list&size=20','_self');
    return false;
});


$('.btn-nshop').on('click',function (e) {
    e.preventDefault();
    window.open('https://bnsnshop.plaync.com/bns/goods/detail?dgi=412800','_blank');
    return false;
});



var ani_main = gsap.timeline()
    .addLabel('start')
    .fromTo('.p-header__bg', { scale: 15 },{ duration: 0.7, scale: 1, ease:"Power1.easeOut"}, 'start+=0.2')
    .fromTo('.p-header__title', 0.3, {scale: 10, autoAlpha: 0},{scale: 1, autoAlpha: 1, ease:"Power2.easeOut", clearProps:"transform"}, 'start+=0.7')
    .fromTo('.p-header__men', 0.3, {scale: 7, autoAlpha: 0},{scale: 1,autoAlpha:1, ease:"Power2.easeOut", clearProps:"transform" ,onComplete:function(){
            particle();
        }}, "start+=0.9")
    .from('.p-header__date', 0.7, {y:50, alpha: 0, ease: "Power2.easeOut", clearProps:"transform"},"start+=1.8")
    .fromTo(".btn-play", 0.4, {scale: 3, autoAlpha: 0},{scale: 1,autoAlpha:1, ease:"Power1.easeOut", clearProps:"transform"}, "start+=1.4")
    .from('.p-header__util', 0.7, {y: -50,autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.8")
    .from(".bg-scroll", 0.7, {y: -50,autoAlpha:0, ease:"Power1.easeOut"}, "start+=2.4")
    .fromTo(".p-header__back", 2,{autoAlpha:0},{autoAlpha:0.9,yoyo: true,ease: "rough({strength: 3, points: 50, template: strong.inOut, taper: both, randomize: false})", repeat:-1})



